export default "__VITE_ASSET__zYAHaV8h__"